import {Component} from '@angular/core';

@Component({
  selector: 'kt-users',
  template: '<router-outlet></router-outlet>'
})
export class UsersComponent {

}
